import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { formatAppointment } from 'utils/formatter.js';
import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from 'theme/tokens';

const CTStepper = ({ stages }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Stepper activeStep={stages.length} alternativeLabel>
      {stages.map(((step,idx) =>
        <Step key={idx}>
          <StepLabel
            sx={{
              '& .MuiStepLabel-alternativeLabel': {
                marginTop: '4px',
              },
              '& .MuiStepIcon-root.Mui-completed': {
                color: colors.success.main,
              }
            }}
          >
            {
              <Box>
                <Typography
                  gutterBottom
                  variant='body1'
                  sx={{marginBottom: 0, fontWeight: 500, color: colors.neutral[900]}}
                >
                  {step.status}
                </Typography>
                <Typography
                  variant='caption'
                  color={colors.neutral[500]}
                >
                  {formatAppointment(step.timestamp)}
                </Typography>
              </Box>
            }
          </StepLabel>
        </Step>
      ))}      
    </Stepper>
  );
};

export default CTStepper;